define('gigaset_csp/components/customer/request',[
	"jquery",
	"cartware/components/_base",
	"cartware/jquery/bem",
	"select2",
	"picker-date",
	"picker-time",
	"bootstrap-button"
], function(
	$,
	Component,
	BEM,
	S2
) {
	return Component.create({
		block: null,

		form:				null,
		varienForm:			null,
		submitButton:		null,

		countrySelect:		null,
		businessUnitSelect:	null,
		producttypeSelect:	null,
		noProducttypeInfo:	null,
		productSelect:		null,
		defectRadios:		null,

		dependDefectBlocks:	null,
		dependUnitBlocks: 	null,

		fault_date:			null,
		fault_time:			null,

		options:			null,

		loading:			false,

		productsLoaded:		false,
		defect:				false,

		$init: function() {
			this.block = BEM.block("csp-customer-request-form");
			this.form = this.block.getElements("form");
			this.submitButton = this.block.getElements("submit-button");
			this.varienForm = new VarienForm(this.form.get(0));

			this.options = this.block.data("config");

			this.countrySelect = this.block.getElements("country_id");
			this.countrySelect
				.on("change", $.proxy(this._onChangeCountry, this))
				.select2();

			this.businessUnitSelect = this.block.getElements("business_unit");
			this.businessUnitSelect
				// .select2()
				.on("change", $.proxy(this._onChangeBusinessUnit, this));

			this.producttypeSelect = this.block.getElements("product_type_id");
			this.producttypeSelect
				.select2()
				.on("change", $.proxy(this._onChangeProducttype, this));

			this.noProducttypeInfo = this.block.getElements("no_product_type_info");

			this.productSelect = this.block.getElements("product_id");
			//this.productSelect.select2();

			this.dependDefectBlocks = this.form.find("[data-depends-defect]");
			this.dependUnitBlocks = this.form.find("[data-depends-businessunit]");

			this.defectRadios = this.block.getElements("assumed_defect");
			this.defectRadios
				.on("change", $.proxy(this._onChangeDefect, this));

			this.countrySelect.change();
			this._onChangeDefect();

			// this.businessUnit.change();

			// this.applyDefectDependencies();
			// this.applyUnitDependencies();

			this.fault_date = this.block.getElements("fault_date");
			this.fault_date.pickadate({
				format: 'yyyy-mm-dd',
				formatSubmit: 'yyyy-mm-dd',
				clear: ''
			});

			this.fault_time = this.block.getElements("fault_time");
			this.fault_time.pickatime({
				format: 'HH:i',
				formatLabel: 'HH:i',
				formatSubmit: 'HH:i',
				clear: ''
			});

			this.form.on("submit", $.proxy(this._onFormSubmit, this));
		},

		setLoading: function(field, flag) {
			this.loading = flag;
			this.block[flag ? "addModifier" : "removeModifier"]("loading-" + field);
		},

		applyDefectDependencies: function() {
			if (this.defect) {
				this.dependDefectBlocks.show();
			} else {
				this.dependDefectBlocks.hide();
			}
		},

		applyUnitDependencies: function() {
			var unit = this.businessUnitSelect.val();
			this.dependUnitBlocks.each(function(){
				var blockUnit = $(this).data('depends-businessunit');
				if (unit && (blockUnit == unit || blockUnit == 0)) {
					$(this).show();
				} else {
					$(this).hide();
				}
			});
		},

		loadProducts: function() {
			if (!this.defect || this.productsLoaded) {
				return;
			}

			var self = this,
				producttype = this.producttypeSelect.val(),
				country = this.countrySelect.val();

			if (!producttype || producttype.length === 0) {
				this._onProductsRetrieve({});
				return;
			}

			var productsFieldName = this.productSelect.attr('name');

			this.setLoading(productsFieldName, true);
			this.productSelect.attr("disabled", "disabled");
			this.productSelect.html("");

			$.ajax(this.options.productOptionsUrl, {
				method: "GET",
				data: {
					producttype: producttype,
					country: country
				}
			})
				.done($.proxy(this._onProductsRetrieve, this))
				.always(function() {
					self.setLoading(productsFieldName, false);
				});
		},

		_onChangeDefect: function() {
			var self = this;
			this.defect = false;

			this.defectRadios.each(function(){
				if (this.checked && this.value == 1) {
					self.defect = true;
				}
			});

			this.applyDefectDependencies();
			this.loadProducts();
		},

		_onChangeCountry: function() {
			var self = this,
				country = this.countrySelect.val();

			// if (country.length && country) {
			// 	this.businessUnitSelect.removeAttr("disabled");
			// } else {
			// 	this.businessUnitSelect
			// 		.val('')
			// 		.attr("disabled", "disabled");
			// }

			this.businessUnitSelect.trigger('change');
		},

		_onChangeBusinessUnit: function() {
			var self = this,
				unit = this.businessUnitSelect.val(),
				country = this.countrySelect.val(),
				selectedOption = this.businessUnitSelect.find('option:selected');

			if (selectedOption) {
				var relocateUrl = selectedOption.data('relocate');
				if (relocateUrl) {
					var win = window.open(relocateUrl, '_blank');
					win.focus();
				}
			}

			this.applyUnitDependencies();

			if (!unit.length || !country.length) {
				this._onProducttypesRetrieve({});
				return;
			}

			var productTypesFieldName = this.producttypeSelect.attr('name');

			this.setLoading(productTypesFieldName, true);
			this.producttypeSelect.attr("disabled", "disabled");
			this.producttypeSelect.html("");

			$.ajax(this.options.productTypeOptionsUrl, {
				method: "GET",
				data: {
					business_unit: unit,
					country: country
				}
			})
				.done($.proxy(this._onProducttypesRetrieve, this))
				.always(function() {
					self.setLoading(productTypesFieldName, false);
				});
		},

		_onChangeProducttype: function() {
			this._onProductsRetrieve({});
			this.loadProducts();
		},

		_onProducttypesRetrieve: function(data) {
			var optionsHtml = [];

			$.each(data, function(key, value) {
				optionsHtml.push('<option value="' + key + '">' + value + '</option>');
			});

			this.producttypeSelect.html(optionsHtml.join(""));

			if (optionsHtml.length) {
				var guid = this.producttypeSelect.attr('value'),
					option = this.producttypeSelect.find('option[value="' + guid +'"]');

				this.producttypeSelect.removeAttr("disabled");
				this.noProducttypeInfo.hide();

				if (option) {
					this.producttypeSelect.val(guid);
					option.attr('selected', 'selected');
				}

				this._onChangeProducttype();
			} else {
				this.producttypeSelect.attr("disabled", "disabled");

				if (this.countrySelect.val() && this.businessUnitSelect.val()) {
					this.noProducttypeInfo.show();
				}

				this._onProductsRetrieve({});
			}

			this.producttypeSelect.select2();
		},

		_onProductsRetrieve: function(data) {
			var optionsHtml = [];

			$.each(data, function(key, value) {
				optionsHtml.push('<option value="' + key + '">' + value + '</option>');
			});

			this.productSelect.html(optionsHtml.join(""));

			if (optionsHtml.length) {
				this.productSelect.removeAttr("disabled");
				this.productsLoaded = true;
			} else {
				this.productSelect.attr("disabled", "disabled");
				this.productsLoaded = false;
			}

			this.productSelect.select2();
		},

		_onFormSubmit: function(e) {
			if (this.loading || !this.varienForm.validator.validate()) {
				e.preventDefault();
				return;
			}

			this.block.addModifier("submitting");
			this.submitButton.button("loading");
		}
	});
});
